<template>
  <v-row ref="parentNode" no-gutters>
    <!-- 코멘트 커서를 위한 영역 -->
    <div
      class="wrap-canvas"
      :style="
        isInIframe
          ? 'width: 100%; aspect-ratio: 16 / 9; cursor: default !important'
          : 'width: 100%; aspect-ratio: 16 / 9; position: absolute'
      "
    >
      <!-- 커스텀 커서 -->
      <div v-if="checked == 'U+2764'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-red-heart size="28"></fluent-emoji-red-heart>
        </div>
      </div>
      <div v-else-if="checked == 'U+2705'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-check-mark-button size="28"></fluent-emoji-check-mark-button>
        </div>
      </div>
      <div v-else-if="checked == 'U+1F972'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-smiling-face-with-tear size="28"></fluent-emoji-smiling-face-with-tear>
        </div>
      </div>
      <div v-else-if="checked == 'U+1F44D'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-thumbs-up size="28"></fluent-emoji-thumbs-up>
        </div>
      </div>
      <div v-else-if="checked == 'U+1F606'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-grinning-squinting-face size="28"></fluent-emoji-grinning-squinting-face>
        </div>
      </div>
      <div v-else-if="checked == 'U+1F4A1'" class="cursor pointed">
        <div class="mt-2" style="margin-left: -2.2px">
          <fluent-emoji-light-bulb size="28"></fluent-emoji-light-bulb>
        </div>
      </div>
      <div v-else class="cursor pointed">
        <div class="add-horizon-bg"></div>
        <div class="add-vertical-bg"></div>
        <div class="add-horizon"></div>
        <div class="py-1 px-2 box-cursor-text">
          {{ 'Drag to Comment' }}
        </div>
      </div>
      <canvas v-if="!isMobile" class="canvas-box-comment" ref="canvas"></canvas>
    </div>

    <div v-if="isDisplay">
      <div
        v-for="comment in displayingComments"
        :key="comment.cmId"
        :ref="`contentZone-${storeSectionIndex}`"
        class="content-zone-displayingComments"
        :class="commentFadeoutMap.get(comment.cmId) ? [`contentZoneFadeOut`] : ``"
        :style="{
          width: comment.boxData.width ? `${comment.boxData.width}% !important` : '',
          height: comment.boxData.height ? `${comment.boxData.height}% !important` : '',
          top: comment.boxData.top ? `${comment.boxData.top}% !important` : '',
          left: comment.boxData.left ? `${comment.boxData.left}% !important` : '',
          display: comment.boxData.width ? '' : 'none !important',
        }"
      ></div>
    </div>

    <div
      v-show="isDrawing"
      :ref="`contentZone-${storeSectionIndex}`"
      class="content-zone"
      :class="{ contentZoneFadeOut: isFadeOut }"
      :style="cssProps"
    ></div>

    <div
      v-show="this.seekTime >= 0"
      :key="containerEmojiKey"
      class="container-emoji"
      style="width: 100%; aspect-ratio: 16 / 9; position: absolute; z-index: 100; pointer-events: none"
    >
      <v-tooltip color="#131b1e" v-for="item in displayingEmojiList" :key="item.localEmojiKey || item.id" top left>
        <template v-slot:activator="{ on }">
          <v-hover v-slot="{ hover }">
            <div
              ref="emojiDiv"
              v-on="on"
              :style="`pointer-events: all; position: absolute; width: 28px; height: 28px; top: ${item.top}% !important; left: ${item.left}% !important`"
            >
              <div class="emoji-border"></div>
              <component
                :is="item.type"
                size="30"
                :class="emojiFadeoutMap.get(item.id) ? [`warpEmojiFadeOut`] : [`warp-emoji`]"
              ></component>
              <transition name="fade" v-if="$store.getters.userInfo">
                <div
                  v-if="
                    (hover && item.userId == $store.getters.userInfo.userId) ||
                    (hover && isMtOrganizer) ||
                    (hover && isSectionOrganizer) ||
                    (hover && isClipOrganizer)
                  "
                  class="delete-emoji"
                  @click.stop="openDeleteEmojiDialog(item)"
                >
                  <span id="emoji-clear" class="material-icons-round" style="font-size: 15px">clear</span>
                </div>
              </transition>
            </div>
          </v-hover>
        </template>
        <span>{{ item.user }}</span>
      </v-tooltip>
    </div>
    <delete-emoji-dialog
      :deleteEmojiVisible.sync="deleteEmojiVisible"
      @close="deleteEmojiVisible = false"
      @confirm="removeEmoji(targetEmoji)"
    ></delete-emoji-dialog>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </v-row>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { setCreateEmoji, setDeleteEmoji, getEmojiList } from '@/services/emoji'
import { mapState, mapGetters } from 'vuex'
import GuestIn from '@/views/modal/GuestIn'
import FluentEmojiCheckMarkButton from '@/views/meeting/component/emoji/FluentEmojiCheckMarkButton'
import FluentEmojiClappingHands from '@/views/meeting/component/emoji/FluentEmojiClappingHands'
import FluentEmojiThinkingFace from '@/views/meeting/component/emoji/FluentEmojiThinkingFace'
import FluentEmojiSmilingFaceWithTear from '@/views/meeting/component/emoji/FluentEmojiSmilingFaceWithTear'
import FluentEmojiBackhandIndexPointingUp from '@/views/meeting/component/emoji/FluentEmojiBackhandIndexPointingUp'
import FluentEmojiRedHeart from '@/views/meeting/component/emoji/FluentEmojiRedHeart'
import DeleteEmojiDialog from '../../modal/DeleteEmojiDialog.vue'
import FluentEmojiThumbsUp from '@/views/meeting/component/emoji/FluentEmojiThumbsUp.vue'
import FluentEmojiGrinningSquintingFace from '@/views/meeting/component/emoji/FluentEmojiGrinningSquintingFace.vue'
import FluentEmojiLightBulb from '@/views/meeting/component/emoji/FluentEmojiLightBulb.vue'

export default {
  name: 'BoxComment',
  props: ['containerWidth', 'containerHeight', 'sectionIndex', 'checked', 'seekTime', 'isShowBoxComment'],
  data() {
    return {
      //모바일인지 확인하는 플래그 값
      isMobile: null,
      //canvas를 할당하는 변수
      ctx: null,

      //게스트 팝업 관련 플래그 값
      guestInVisible: false,

      //현재는 안쓰이는 것 같음
      guestInActionType: '',

      //Fade Out 적용 상수값
      MAP_FADEOUT_SET_TIME: 2,

      //Visual Comment 관련

      //box data 값
      box: null,

      //drawing 관련 값
      drawingStartX: -1,
      drawingStartY: -1,

      //css 스타일링 관련 값
      cssProps: '',

      //댓글에 담긴 박스데이터로 그린 박스 보여줄지 말지 정하는 플래그 값
      isDisplay: false,

      //그리는 박스인지 아닌지 판단하는 플래그 값
      isDrawing: false, // Video 영역 클릭 - 드래그 - 해제까지 true, 즉, 상자를 그리는 동안

      //박스를 다 그리고 나면 true로 바뀌는 플래그 값
      isDrawn: false, // Comment 클릭이 아닌 Video 영역으로 그린 상자가 표시되는 동안 true

      //사용안함
      fadeOutTimer: null,
      MIN_SIZE: 2.5, // 커멘트 Box의 최소 크기로 상수 선언으로 변경 필요

      //댓글이 가지고 있는 박스를 화면에 보일때 댓글을 저장하는 배열
      displayingComments: [],

      //랜덤액세스로 필터링해서 댓글을 담아주는 배열
      filteredComments: [],

      //댓글이 사라지는 값을 저장하는 맵
      commentFadeoutMap: new Map(),

      //Emoji 관련

      //해당 클립이 가지고 있는 이모지 리스트를 저장하는 배열
      emojiList: [], // emojiList should always be sorted in ascending order

      //랜덤액세스로 필터링해서 이모지를 담아주는 배열
      filteredEmojiList: [], // filteredEmojiList is to be used to filter emojis to display at certain time

      //이모지가 사라지는 값을 저장하는 맵
      emojiFadeoutMap: new Map(),
      EMOJI_DISPLAY_TIME: 0.15,
      EMOJI_DELETE_TIME: 4,

      //사용안함
      fadeOutEmojiValue: 0,

      //화면에 보여줄 이모지를 저장하는 배열
      displayingEmojiList: [],

      //이모지 삭제 다이얼로그 플래그 값
      deleteEmojiVisible: false,

      //삭제할 이모지를 저장하는 변수 (아마도 타겟)
      targetEmoji: null,

      //사용안함
      isEmojiSkeletonloading: false,

      //이모지 컨테이너 관련 키 값
      containerEmojiKey: 0,

      //사용안함
      emojiListWithType: [],

      //로컬에서 먼저 이모지 저장할떄 쓰는 키 값 같음
      localEmojiKey: 0,

      //사용안함
      showEmoji: [],

      //해당 클립이 가지고 있는 피드백 이모지 리스트를 저장하는 배열
      feedbackEmojiList: [],

      //뭔가 피드백 이모지와 관련 있는 값처럼 보임
      countedEmojiList: [
        {
          unicode: 'U+2705',
          emojiName: 'Check Mark',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+1F44F',
          emojiName: 'Clapping Hands',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+2764',
          emojiName: 'Red Heart',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
        {
          unicode: 'U+1F440',
          emojiName: 'Eyes',
          count: 0,
          value: false,
          id: null,
          uniqueValue: [],
          user: [],
          self: '',
        },
      ],
    }
  },
  components: {
    GuestIn,
    FluentEmojiClappingHands,
    FluentEmojiCheckMarkButton,
    FluentEmojiThinkingFace,
    FluentEmojiSmilingFaceWithTear,
    FluentEmojiBackhandIndexPointingUp,
    FluentEmojiRedHeart,
    DeleteEmojiDialog,
    FluentEmojiGrinningSquintingFace,
    FluentEmojiThumbsUp,
    FluentEmojiLightBulb,
  },
  mounted() {
    if (!this.isInIframe) {
      this.ctx = this.$refs.canvas.getContext('2d')
      window.addEventListener('mousedown', this.windowMouseDown)

      this.$refs.canvas.addEventListener('mousedown', this.onVideoMouseDown)
      this.$refs.canvas.addEventListener('mouseup', this.onVideoMouseUp)
      this.$refs.canvas.addEventListener('mousemove', this.onVideoMouseDrag)

      this.isMobile = isMobile()

      // 기존 커서 위치에 따라다니는 div
      let cursorPointed = document.querySelectorAll('.pointed')
      let wrapCanvas = document.querySelectorAll('.wrap-canvas')

      for (let i = 0; i < wrapCanvas.length; i++) {
        const moveCursor = (e) => {
          const rect = wrapCanvas[i] && wrapCanvas[i]?.getBoundingClientRect()
          const mouseY = e.clientY - rect.top
          const mouseX = e.clientX - rect.left
          cursorPointed[i].style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`
        }

        wrapCanvas[i].addEventListener('mousemove', moveCursor)
        wrapCanvas[i].addEventListener('mouseenter', function () {
          cursorPointed[i].style.display = 'inline-block'
        })

        wrapCanvas[i].addEventListener('mouseleave', function () {
          cursorPointed[i].style.display = 'none'
        })
      }
    }
  },
  created() {
    this.$root.$refs[`BoxComment-${this.sectionIndex}`] = this
    this.emojiList = []
    this.$store.dispatch('setEmoticonList', null)
    this.initEmojiList()
    this.initComments()

    if (!this.isPreview) {
      this.getEmojiList()
    }
  },
  methods: {
    // Comment 관련 메소드들 🔥🔥🔥

    initBoxValue() {
      //박스 초기화 메소드
      // console.log('initBoxValue, 박스커멘트.Vue')
      this.box = null
    },

    addToDisplayingCommentList(item) {
      //화면에 보이는 커멘트 리스트에 추가하는 메소드
      // console.log('addToDisplayingCommentList, 박스커멘트.Vue', item)
      if (!item) return
      this.displayingComments.push(item)
    },

    playCommentPlay(comment, index) {
      //커멘트 플레이 시 커멘트 프리뷰 등 커멘트 플레이 관련 처리하는 메소드
      // console.log('playCommentPlay, 박스커멘트.Vue', comment, index)
      this.handleCommentPlay(comment)

      this.$nextTick(() => {
        this.$set(this.commentPlayComponent.showCommentPlay, index, true)
        if (index > 0) {
          this.$set(this.commentPlayComponent.showCommentPlay, index - 1, false)
        }
      })

      // this.$store.dispatch('setClickcmId', comment)
    },

    removePlayingComments(time) {
      //커멘트 플레이 시 일정 시간 지난 커멘ㅌ트는 화면에서 사라지게 하는 메소드
      // console.log('removePlayingComments, 박스커멘트.Vue', time)
      if (this.displayingComments?.length <= 0) return

      for (let i = this.displayingComments.length; i >= 0; i--) {
        if (Math.abs(this.displayingComments[i]?.boxData.time - time) > this.MAP_FADEOUT_SET_TIME) {
          if (this.commentFadeoutMap.get(this.displayingComments[i].cmId)) {
            break
          } else if (Math.abs(this.displayingComments[i]?.boxData.time - time) > this.MAP_FADEOUT_SET_TIME) {
            this.commentFadeoutMap.set(this.displayingComments[i].cmId, true)
          }
        }
      }

      for (let i = 0; i < this.displayingComments.length; i++) {
        if (Math.abs(this.displayingComments[i].boxData.time - time) > this.EMOJI_DELETE_TIME) {
          this.commentFadeoutMap.delete(this.displayingComments[i].cmId)
          this.displayingComments.splice(i, 1)
          i--
          this.initBoxValue()
        }
      }

      if (this.displayingComments?.length === 0) {
        this.$store.dispatch('setClickEmojiId', false)
      }
    },

    async displayComments(time) {
      //커멘트 플레이 시 커멘트가 가지고 있는 시간에 따라 화면에 보이게 하는 메소드
      // console.log('displayComments, 박스커멘트.Vue', time)
      // if (this.iconList === undefined || this.iconList === null || this.iconList?.length <= 0) return
      if (this.filteredComments?.length === 0) {
        // this.resetDisplayingEmojiList()
        // this.$store.dispatch('setClickEmojiId', false)
        return
      }

      for (let i = 0; i < this.filteredComments?.length; i++) {
        let comment = this.filteredComments[i]
        if (Math.abs(comment.boxData.time - time) <= this.EMOJI_DISPLAY_TIME) {
          //TODO 0.15 상수로 빼기
          this.filteredComments.splice(i, 1)
          i--

          this.commentFadeoutMap.set(comment.cmId, false)
          this.addToDisplayingCommentList(comment)
          this.playCommentPlay(comment, i)

          // this.$store.dispatch('setClickcmId', comment)

          // this.$set(this.commentPlayComponent.showCommentPlay, i, true)
        } else if (comment.boxData.time < time) {
          this.filteredComments.splice(i, 1)
          i--
        } else {
          break
        }
      }
    },

    initComments() {
      //커멘트 초기화 메소드
      // console.log('initComments, 박스커멘트.Vue')
      this.resetDisplayingComments()
      this.filteredComments = []
    },

    onCommentRandomAccess(time) {
      // 영상 시간에 따라 filtered Comments를 변경하는 메소드
      // console.log('onCommentRandomAccess, 박스커멘트.Vue', time)
      // 보여지고 있는 displayingComments를 초기화
      this.resetDisplayingComments()

      // 다시 filteredComments 배열에 댓글 배열을 할당
      this.filteredComments = this.iconList ? [...this.iconList] : []
      // this.$store.dispatch('setFilteredDisplayingEmojiList', this.filteredEmojiList)

      // disPlayComments에 시간을 넘긴다
      this.displayComments(time)
    },

    resetDisplayingComments() {
      //보여지고 있는 커멘트 리스트를 초기화하는 메소드
      // console.log('resetDisplayingComments, 박스커멘트.Vue')
      this.displayingComments = []
      this.commentFadeoutMap.clear()
    },

    clearTime(timeOutValue) {
      //setTimeout Timer value를 초기화하는 메소드
      // console.log('clearTime, 박스커멘트.Vue', timeOutValue)
      clearTimeout(timeOutValue)
    },

    // onCommentPlay(time) {
    //   console.log('onCommentPlay, 박스커멘트.Vue', time)
    //   if (!this.$store.getters.isCommentPlayOn) return
    //   if (this.iconList && this.iconList !== null) {
    //     this.iconList.forEach((comment) => {
    //       if (Math.abs(comment.boxData.time - time) < 0.15) {
    //         this.commentFadeoutMap.set(comment.cmId, false)
    //         this.addToDisplayingCommentList(comment)
    //         this.playCommentPlay(comment)
    //       } else if (Math.abs(comment.boxData.time - time) < 0.5 && comment.boxData.time === 0) {
    //         this.commentFadeoutMap.set(comment.cmId, false)
    //         this.addToDisplayingCommentList(comment)
    //         this.playCommentPlay(comment)
    //       }
    //     })
    //   }
    // },

    // fadeOutAnimationByIndex(index) {
    //   let style = {}
    //   style.animation = 'fadeout 4s'
    //   return style
    // },

    windowMousedownConditions(e) {
      // 바깥 쪽 마우스 클릭 관련 조건 함수
      return (
        e.target !== this.$refs.canvas &&
        e.target.id !== 'playButton' &&
        e.target.id !== 'commentInputBoxId' &&
        e.target.id !== 'postBtn' &&
        e.target.className !== 'textBox' &&
        e.target.className !== 'commentInputBoxInside' &&
        e.target.className !== 'PublishBtn' &&
        e.target.className !== 'postBtn' &&
        e.target.className !== 'v-btn__content' &&
        e.target.className !== 'container-emoji' &&
        e.target.className !== 'emoji-border' &&
        e.target.id !== 'emoji-clear' &&
        e.target.className !== 'btn-delete-emoji' &&
        e.target.getAttribute('class') !== 'emoji-svg' &&
        e.target.className !== 'v-responsive__content' &&
        e.target.localName !== 'svg' &&
        e.target.localName !== 'path' &&
        e.target.localName !== 'ellipse' &&
        e.target.localName !== 'circle' &&
        e.target.localName !== 'label' &&
        e.target.className !== 'kbd-key ml-1'
      )
    },

    windowMouseDown(e) {
      // window 마우스 다운 이벤트
      //e.target으로 이 메소드가 작동하면 안되는곳 조건문에 넣음
      if (this.windowMousedownConditions(e) && !this.$store.getters.isGuestVisible) {
        //게스트 sign-in으로 댓글 남길 시, 박스 해제 안함

        // Video 영역 외부 클릭 시 상자 삭제

        this.removeBox()

        if (this.$store.getters.isTranscriptCardClicked) {
          this.$store.dispatch('setIsTranscriptCardClicked', null)
        }

        if (this.$store.getters.isCommentIconClicked) {
          this.$store.dispatch('setIsCommentIconClicked', null)
        }

        if (this.$store.getters.isSummaryIconClicked) {
          this.$store.dispatch('setIsSummaryIconClicked', null)
        }

        if (this.$store.getters.clickedSummaryTimestamp) {
          this.$store.dispatch('setClickedSummaryTimestamp', null)
        } else if (this.$store.getters.clickedSummaryTimestamp === 0) {
          this.$store.dispatch('setClickedSummaryTimestamp', null)
        }

        if (this.$store.getters.clickedTranscriptCard) {
          this.$store.dispatch('setClickedTranscriptCard', null)
        }

        if (this.$store.getters.clickedSummaryCard) {
          this.$store.dispatch('setClickedSummaryCard', null)
        }

        //커멘트 카드가 클릭 되어있으면 해제
        if (this.$store.getters.clickCommentId) {
          this.$store.dispatch('setClickcmId', false)
        }

        if (this.$store.getters.clickEmojiId) {
          this.$store.dispatch('setClickEmojiId', false)
        }

        if (!this.$store.getters.commentPlayPreview) {
          this.$store.dispatch('setCommentPlayPreview', true)
        }

        if (!this.$store.getters.emojiPlayOn) {
          this.$store.dispatch('setEmojiPlayOn', true)
        }

        // //바깥쪽 클릭하면 화면에 그려진 이모지 초기화
        // if (this.displayingEmojiList.length > 0) {
        //   this.resetDisplayingEmojiList()
        // }
      }
    },

    onVideoMouseDown(e) {
      // video 마우스 다운 이벤트
      if (this.isShowBoxComment) {
        this.removeBox()
        this.displayingComments = []

        this.drawingStartX = (parseInt(e.offsetX) / this.$refs.canvas.width) * 100
        this.drawingStartY = (parseInt(e.offsetY) / this.$refs.canvas.height) * 100

        this.calculateBox(this.drawingStartX, this.drawingStartY)

        this.checked == 'dragtocomment'
          ? (this.drawBox(true), (this.isDrawing = true))
          : (this.drawEmoji(), (this.isDrawing = false))

        this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
        if (this.checked == 'dragtocomment') this.$store.dispatch('setBoxDrawn', false)
        this.$store.dispatch('setIsFadeOut', false)
        this.$store.dispatch('setIsEmojiFadeOut', false)

        //박스 그린 뒤 영상 재생 시 박스 사라지는 값 해제
        this.clearTime(this.videoControlBarComponent.timeOutValueForVideoControlBar)
        //영상 재생 중 removeCommentPlay ClearTimeOut 과 CommentPlayPreview 끄기

        this.clearTime(this.removeCommentPlayTimeOut.timer)
        // this.$store.dispatch('setCommentPlayTimeOutValue', 0)
        if (this.commentPlayComponent)
          this.$set(this.commentPlayComponent.showCommentPlayArray(), this.removeCommentPlayTimeOut.index, false)
      }
    },

    onVideoMouseUp(e) {
      // video 마우스 업 이벤트
      if (this.isShowBoxComment) {
        if (this.drawingStartX === -1 || this.drawingStartY === -1 || this.box === null) return
        this.isDrawn = true

        let x = (parseInt(e.offsetX) / this.$refs.canvas.width) * 100
        let y = (parseInt(e.offsetY) / this.$refs.canvas.height) * 100

        this.calculateBox(x, y)
        if (this.checked == 'dragtocomment') this.drawBox(false)

        this.drawingStartX = -1
        this.drawingStartY = -1
        this.box = this.getBoxData()

        if (this.checked == 'dragtocomment') this.$store.dispatch('setBoxDrawn', true)
        this.$store.dispatch('setClickcmId', false)

        this.$store.dispatch('setIsCommentIconClicked', true)
      }
    },

    onVideoMouseDrag(e) {
      // video 마우스 드래그 이벤트
      if (this.isShowBoxComment) {
        if (e.which !== 1) return
        if (this.drawingStartX === -1 || this.drawingStartY === -1) return

        let x = (parseInt(e.offsetX) / this.$refs.canvas.width) * 100
        let y = (parseInt(e.offsetY) / this.$refs.canvas.height) * 100

        this.calculateBox(x, y)
        if (this.checked == 'dragtocomment') this.drawBox(true)
        this.isDrawing = true
      }
    },

    //getBoxData로는 박스가 없으면 댓글을 남길 수 없다. 조건문에서 박스가 있는것만 체크하니깐
    getBoxData(time) {
      // 댓글 남길때 박스 데이터가 있으면 시간과 함께 객체 값 반환 하는 메소드
      if (this.box === null) return null
      return {
        width: this.box.width,
        height: this.box.height,
        top: this.box.top,
        left: this.box.left,
        time: time < this.duration && time ? time : 0,
      }
    },

    getTimeOnlyCommentData(isReply, parentCommentData) {
      //댓글 남길때 박스 데이터가 없으면 시간만 반환하는 메소드

      let time = this.$store.getters.seekTimeDecimal

      if (isReply) {
        time = parentCommentData
      }
      if (this.currentClip.clipType === 'text') time = 0

      //clipType이 텍스트면 시간을 항상 0으로 세팅 아니면 시간을 전역에서 가져온다.
      return {
        // time: this.currentClip.clipType === 'text' ? 0 : this.$store.getters.seekTimeDecimal,
        time: time < this.duration && time ? time : 0,
      }
    },

    handleCommentClickEvent(comment) {
      //DetailComment의 커멘트 카드가 클릭 시 처리 메소드
      // console.log('handleCommentClickEvent 박스 커멘트.vue', comment)
      //박스 그리고 있지 않으니 isDrawing false 처리
      this.isDrawing = false

      //영상 멈추기 트리깅
      this.$store.dispatch('setIsPauseSeek', false)
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)

      //인자로 넘겨 받은 Comment를 통해 박스 그리기
      this.setBoxFromComment(comment)
      this.drawBox(false)
    },

    handleCommentPlay(comment) {
      //CommentPlay 시 박스 그리기 메소드
      // console.log('handleCommentPlay 박스 커멘트.vue', comment)
      this.setBoxFromComment(comment)
      this.drawBox(false)

      // if (!comment.boxData.width || !comment.boxData.height || !comment.boxData.top || !comment.boxData.left) {
      //   // this.removeBox()
      // }
    },

    handleCommentInputClickEvent() {
      //댓글 인풋창 클릭 시 처리 메소드
      // console.log('handleCommentInputClickEvent 박스 커멘트.vue')
      if (this.isDrawn) return
      else if (!this.isDrawn) {
        this.removeBox()
        this.$store.dispatch('setBoxDrawn', true)
      }

      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
      // this.removeBox()
      //만약에 댓글 인풋창을 클릭 했을 때 댓글 카드를 클릭한게 있으면 지우고 그 해당 박스도 삭제
      if (this.commentBoxData) {
        this.removeBox()
        this.displayingComments = []
        this.$store.dispatch('setClickcmId', false)
      }
    },

    initBox(x, y) {
      //박스 초기화 메소드
      // console.log('initBox 박스 커멘트.vue', x, y)
      // To avoid 0 width / 0 height
      this.box = {
        top: y,
        left: x,
        width: 1,
        height: 1,
      }
    },

    setBoxFromComment(comment) {
      //Comment가 가지고 있는 박스 데이터를 받아서 박스 그리기
      // console.log('setBoxFromComment 박스 커멘트.vue', comment)
      if (
        comment === null ||
        comment === undefined ||
        comment.boxData === null ||
        comment.boxData === undefined ||
        comment.boxData.top === null ||
        comment.boxData.top === undefined ||
        comment.boxData.left === null ||
        comment.boxData.left === undefined ||
        comment.boxData.width === null ||
        comment.boxData.width === undefined ||
        comment.boxData.height === null ||
        comment.boxData.height === undefined
      ) {
        return
      }
      this.box = {
        top: comment.boxData.top,
        left: comment.boxData.left,
        width: comment.boxData.width,
        height: comment.boxData.height,
      }
    },
    // setEmojiFromEmojiList(emoji) {
    //   //이모지를 두번 클릭하면 이모지가 안보이는 현상 방지

    //   if (emoji === null || emoji === undefined || emoji.positionX === null) {
    //     return
    //   }
    //   this.displayingEmojiList.push({
    //     id: emoji.emojiId,
    //     type: emoji.type,
    //     top: emoji.positionY,
    //     left: emoji.positionX,
    //     time: emoji.emojiTime,
    //     user: this.$store.getters.userInfo.userDisplayName || this.$store.getters.userInfo.userFullName,
    //     userId: this.$store.getters.userInfo.userId,
    //   })
    // },

    calculateBox(newX, newY) {
      //박스 좌표 계산 메소드
      // console.log('calculateBox 박스 커멘트.vue', newX, newY)
      if (this.box === null) {
        this.initBox(newX, newY)
        return
      }

      this.box.left = this.drawingStartX < newX ? this.drawingStartX : newX
      this.box.top = this.drawingStartY < newY ? this.drawingStartY : newY
      this.box.width = Math.abs(this.drawingStartX - newX)
      this.box.height = Math.abs(this.drawingStartY - newY)
    },

    drawBox(isDragging) {
      //박스 그리기 메소드
      // console.log('drawBox 박스 커멘트.vue', isDragging)
      if (
        this.box === undefined ||
        this.box === null ||
        this.box.top < 0 ||
        this.box.left < 0 ||
        this.box.width < 0 ||
        this.box.height < 0
      ) {
        // this.removeBox()
        return
      } else {
        let boxWidth = this.box.width
        let boxHeight = this.box.height

        if (!isDragging && boxWidth === 0 && boxHeight === 0) {
          boxWidth = this.MIN_SIZE
          boxHeight = (boxWidth / this.$refs.canvas.height) * this.$refs.canvas.width
        }
        if (isDragging) {
          this.cssProps = `width: ${boxWidth}% !important; height: ${boxHeight}% !important; top: ${this.box.top}% !important; left: ${this.box.left}% !important`
        }
        this.isDisplay = true
      }
    },

    removeBox() {
      //박스 삭제 메소드
      // console.log('removeBox 박스 커멘트.vue')
      this.isDisplay = false
      this.isDrawn = false
      this.box = null
      this.cssProps = ''

      //댓글 입력창에 하이라이트 스타일링이 있으면 해제
      if (this.$store.getters.boxDrawn) {
        this.$store.dispatch('setBoxDrawn', false)
      }
    },

    getEmojiType(unicode) {
      //이모지 타입 메소드
      // console.log('getEmojiType 박스 커멘트.vue', unicode)
      let type = 'U+2764' // Default is red heart.
      switch (unicode) {
        case 'U+1F44F':
          type = 'FluentEmojiClappingHands'
          break
        case 'U+1F446':
          type = 'FluentEmojiBackhandIndexPointingUp'
          break
        case 'U+2764':
          type = 'FluentEmojiRedHeart'
          break
        case 'U+2705':
          type = 'FluentEmojiCheckMarkButton'
          break
        case 'U+1F914':
          type = 'FluentEmojiThinkingFace'
          break
        case 'U+1F972':
          type = 'FluentEmojiSmilingFaceWithTear'
          break
        case 'U+1F44D':
          type = 'FluentEmojiThumbsUp'
          break
        case 'U+1F606':
          type = 'FluentEmojiGrinningSquintingFace'
          break
        case 'U+1F4A1':
          type = 'FluentEmojiLightBulb'
          break
      }
      return type
    },

    addToDisplayingEmojiList(item) {
      //이모지를 화면에 표시하는 배열에 추가하는 메소드
      // console.log('addToDisplayingEmojiList 박스 커멘트.vue', item)
      if (!item) return

      item.localEmojiKey = this.localEmojiKey++
      this.displayingEmojiList.push(item)
    },

    async displayEmoji(time) {
      //이모지를 화면에 표시하는 메소드
      // console.log('displayEmoji 박스 커멘트.vue', time)
      if (this.emoticonList === undefined || this.emoticonList === null || this.emoticonList?.length <= 0) return
      if (this.filteredEmojiList?.length === 0) {
        // this.resetDisplayingEmojiList()
        // this.$store.dispatch('setClickEmojiId', false)
        return
      }

      for (let i = 0; i < this.filteredEmojiList?.length; i++) {
        let emoji = this.filteredEmojiList[i]
        if (Math.abs(emoji.emojiTime - time) <= this.EMOJI_DISPLAY_TIME) {
          //TODO 0.15 상수로 빼기
          this.filteredEmojiList.splice(i, 1)
          i--
          this.emojiFadeoutMap.set(emoji.emojiId, false)
          this.addToDisplayingEmojiList({
            id: emoji.emojiId,
            type: this.getEmojiType(emoji.unicode),
            top: emoji.positionY,
            left: emoji.positionX,
            time: emoji.emojiTime,
            user: emoji.userInfo.userDisplayName || emoji.userInfo.userFullName,
            userId: emoji.userId,
          })
          this.$store.dispatch('setClickEmojiId', emoji)

          // this.$set(this.commentPlayComponent.showEmojiPlay, i, true)

          // if (this.isEmojiFadeOut) {
          //   setTimeout(async () => {
          //     await this.$store.dispatch('setIsEmojiFadeOut', false)
          //     await this.$store.dispatch('setIsEmojiFadeOut', true)
          //   }, 2000)
          // }
        } else if (emoji.emojiTime < time) {
          this.filteredEmojiList.splice(i, 1)
          i--
        } else {
          break
        }
      }
    },

    onRandomAccess(time) {
      //이모지 배열 영상 시간 랜덤 액세스 시 호출되는 메소드
      // console.log('onRandomAccess 박스 커멘트.vue', time)
      this.resetDisplayingEmojiList()
      this.filteredEmojiList = this.emojiList ? [...this.emojiList] : []
      this.$store.dispatch('setFilteredDisplayingEmojiList', this.filteredEmojiList)
      this.displayEmoji(time)
    },

    resetDisplayingEmojiList() {
      //이모지 배열 초기화 메소드
      // console.log('resetDisplayingEmojiList 박스 커멘트.vue')
      this.localEmojiKey = 0
      this.displayingEmojiList = []
      this.emojiFadeoutMap.clear()
    },

    addToEmojiList(item) {
      //이모지 배열에 추가하는 메소드
      // console.log('addToEmojiList 박스 커멘트.vue', item)
      if (!item) return
      this.emojiList.push(item)

      this.emojiList.sort((a, b) => {
        return a.emojiTime - b.emojiTime
      })
      this.filteredEmojiList = [...this.emojiList]
      this.$store.dispatch('setFilteredDisplayingEmojiList', this.filteredEmojiList)
    },

    removeFromEmojiList(item) {
      //이모지 배열에서 삭제하는 메소드
      // console.log('removeFromEmojiList 박스 커멘트.vue', item)
      if (!item) return

      for (let i = 0; i < this.emojiList.length; i++) {
        if (this.emojiList[i].emojiId == item.id) {
          this.emojiList.splice(i, 1)
          i--
        }
      }
    },

    removePlayingEmoji(time) {
      // 이모지 Play 시 화면에서 일정 시간 흐른 이모지 제거
      // console.log('removePlayingEmoji 박스 커멘트.vue', time)
      if (this.displayingEmojiList?.length <= 0) return

      // TODO 부르는 타이밍 정리 및 아래 코드 효율화 각 변수 상수로 관리
      for (let i = this.displayingEmojiList.length; i >= 0; i--) {
        if (Math.abs(this.displayingEmojiList[i]?.time - time) > this.MAP_FADEOUT_SET_TIME) {
          if (this.emojiFadeoutMap.get(this.displayingEmojiList[i].id)) {
            break
          } else if (Math.abs(this.displayingEmojiList[i]?.time - time) > this.MAP_FADEOUT_SET_TIME) {
            this.emojiFadeoutMap.set(this.displayingEmojiList[i].id, true)
          }
        }
      }

      // for (let i = 0; i < this.displayingEmojiList.length; i++) {
      //   if (Math.abs(this.displayingEmojiList[i].time - time) > MAP_FADEOUT_SET_TIME) {
      //     if (!this.emojiFadeoutMap.get(this.displayingEmojiList[i].id))
      //       this.emojiFadeoutMap.set(this.displayingEmojiList[i].id, true)
      //   }
      // }

      for (let i = 0; i < this.displayingEmojiList.length; i++) {
        if (Math.abs(this.displayingEmojiList[i].time - time) > this.EMOJI_DELETE_TIME) {
          this.emojiFadeoutMap.delete(this.displayingEmojiList[i].id)
          this.displayingEmojiList.splice(i, 1)
          i--
        }
      }

      if (this.displayingEmojiList?.length === 0) {
        this.$store.dispatch('setClickEmojiId', false)
      }
    },

    drawEmoji() {
      //이모지 그리는 메소드
      // console.log('drawEmoji 박스 커멘트.vue')
      let type = this.getEmojiType(this.checked)

      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = 'guestEmoji'
        this.guestInVisible = true
      } else {
        if (!this.emojiList) this.emojiList = []

        let seekTime = this.videoControlBarComponent.seekTime / 1000

        this.addToEmojiList({
          emojiId: this.localEmojiKey,
          emojiTime: seekTime,
          positionX: this.box.left,
          positionY: this.box.top,
          type: type,
          unicode: this.checked,
          // userInfo: { userDisplayName: this.$store.getters.userInfo.userDisplayName },
          userInfo: this.$store.getters.userInfo,
          userId: this.$store.getters.userInfo.userId,
          local: true,
        })

        // this.addToDisplayingEmojiList({
        //   id: this.localEmojiKey,
        //   time: this.videoControlBarComponent.seekTime / 1000,
        //   left: this.box.left,
        //   top: this.box.top,
        //   type: type,
        //   user: this.$store.getters.userInfo.userDisplayName,
        //   userId: this.$store.getters.userInfo.userId,
        //   local: true,
        // })

        this.setCreateEmoji(this.localEmojiKey)
        this.$store.dispatch('setEmoticonList', this.emojiList)
        this.displayEmoji(seekTime)

        this.localEmojiKey += 1
      }
    },

    removeEmoji(item) {
      //이모지 삭제하는 메소드
      // console.log('removeEmoji 박스 커멘트.vue', item)
      this.removeFromEmojiList(item)
      for (let j = 0; j < this.displayingEmojiList.length; j++) {
        if (this.displayingEmojiList[j].id == item.id) {
          this.displayingEmojiList.splice(j, 1)
          j--
        }
      }
      this.$store.dispatch('setEmoticonList', this.emojiList)
      this.deleteEmojiVisible = false
      this.setDeleteEmoji(item)
    },

    async setCreateEmoji(key) {
      //이모지 생성 메소드
      // console.log('setCreateEmoji 박스 커멘트.vue', key)
      try {
        let response = await setCreateEmoji(
          this,
          this.currentClip.clipId,
          this.checked,
          'visual',
          this.box.left,
          this.box.top,
          this.videoControlBarComponent.seekTime / 1000
        )
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'create_on_video_emoji',
          eventParam: {
            name: 'create_on_video_emoji',
          },
        })
        for (let i = 0; i < this.emojiList.length; i++) {
          if (this.emojiList[i].emojiId == key) {
            this.emojiList[i].emojiId = response.emojiId
          }
        }
        for (let i = 0; i < this.displayingEmojiList.length; i++) {
          if (this.displayingEmojiList[i].id == key) {
            this.displayingEmojiList[i].id = response.emojiId
          }
        }
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.$t('setEmojiError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('setEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.getEmojiList()
      }
    },

    async setDeleteEmoji(item) {
      //이모지 제거 메소드
      // console.log('setDeleteEmoji 박스 커멘트.vue', item)
      try {
        await setDeleteEmoji(this, this.currentClip.clipId, item.id, 'emoji')

        this.$store.dispatch('setFirebaseLog', {
          eventName: 'delete_on_video_emoji',
          eventParam: {
            name: 'delete_on_video_emoji',
          },
        })
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.$t('deleteEmojiError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteEmojiError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.getEmojiList()
      }
    },

    initEmojiList() {
      //이모지 리스트 초기화
      // console.log('initEmojiList 박스 커멘트.vue')
      this.emojiList = []
      this.resetDisplayingEmojiList()
      this.filteredEmojiList = []
    },

    async getEmojiList() {
      //이모지 리스트 가져오는 메소드
      // console.log('getEmojiList 박스 커멘트.vue')
      try {
        let result = await getEmojiList(this, this.currentClip.clipId)
        this.initEmojiList()

        let targetList = result.visualList ?? result.feedbackList
        if (targetList && targetList.length && targetList[0].clipId != this.currentClip.clipId) return

        this.emojiList = result.visualList
        this.feedbackEmojiList = result.feedbackList

        if (this.emojiList) {
          this.emojiList.map((emoji) => {
            emoji.type = this.getEmojiType(emoji.unicode)
            return emoji
          })
        }

        await this.$store.dispatch('setEmoticonList', this.emojiList)
        if (this.feedbackEmojiList) {
          this.getEmojiCount()
          this.getEmojivalue()
        }
        this.$store.dispatch('setFeedbackEmoji', this.countedEmojiList)
      } catch (error) {
        console.log(error)
      } finally {
        // emojiList should always be sorted in ascending order
        if (this.emojiList) {
          this.emojiList.sort((a, b) => {
            return a.emojiTime - b.emojiTime
          })
          this.filteredEmojiList = [...this.emojiList]
          this.$store.dispatch('setFilteredDisplayingEmojiList', this.filteredEmojiList)
        }
        this.displayEmoji(this.seekTime)
      }
    },
    openDeleteEmojiDialog(item) {
      //이모지 삭제 다이얼로그 처리하는 메소드
      // console.log('openDeleteEmojiDialog 박스 커멘트.vue', item)
      this.targetEmoji = item
      this.deleteEmojiVisible = true
    },

    getEmojiCount() {
      //이모지 카운트 가져오는 메소드
      // console.log('getEmojiCount 박스 커멘트.vue')
      if (!this.feedbackEmojiList) {
        for (let i = 0; i < this.countedEmojiList.length; i++) {
          this.countedEmojiList[i].count = 0
          this.countedEmojiList[i].value = false
        }
        return
      }

      for (let j = 0; j < this.countedEmojiList.length; j++) {
        this.countedEmojiList[j].uniqueValue = []
        this.countedEmojiList[j].user = []

        this.countedEmojiList[j].count = this.feedbackEmojiList.filter(
          (x) => x.unicode == this.countedEmojiList[j].unicode
        ).length

        this.countedEmojiList[j].uniqueValue = this.feedbackEmojiList.filter(
          (x) => x.unicode == this.countedEmojiList[j].unicode
        )
      }

      for (let i = 0; i < this.countedEmojiList.length; i++) {
        for (let j = 0; j < this.countedEmojiList[i].uniqueValue.length; j++) {
          this.countedEmojiList[i].user.push({
            id: this.countedEmojiList[i].uniqueValue[j].userInfo.userId,
            name:
              this.countedEmojiList[i].uniqueValue[j].userInfo.userDisplayName ||
              this.countedEmojiList[i].uniqueValue[j].userInfo.userFullName,
          })
        }
      }
    },

    getEmojivalue() {
      //이모지 값 가져오는 메소드 (정확히 뭔지 모르겠음)
      // console.log('getEmojivalue 박스 커멘트.vue')
      if (!this.userInfo) return

      let valueedEmojiList = this.feedbackEmojiList.filter((x) => x.userId == this.userInfo.userId)
      for (let j = 0; j < this.countedEmojiList.length; j++) {
        this.countedEmojiList[j].value = false
      }

      for (let i = 0; i < valueedEmojiList.length; i++) {
        for (let j = 0; j < this.countedEmojiList.length; j++)
          if (valueedEmojiList[i].unicode == this.countedEmojiList[j].unicode) {
            this.countedEmojiList[j].value = true
            this.countedEmojiList[j].id = valueedEmojiList[i].emojiId
          }
      }
    },
    autoUpdate() {
      //자동 업데이트 메소드 (이것도 정확히 무슨 처리를 해주는지 모르겠음)
      // console.log('autoUpdate 박스 커멘트.vue')
      this.containerEmojiKey += 1
      this.initEmojiList()
      this.getEmojiList()
    },
    closeGuestIn() {
      //게스트 인 메소드 (게스트 관련 메소드인데 정확히 뭘 하는지 모르겠음)
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        if (!this.emojiList) this.emojiList = []

        let seekTime = this.videoControlBarComponent.seekTime / 1000

        this.addToEmojiList({
          emojiId: this.localEmojiKey,
          emojiTime: seekTime,
          positionX: this.box.left,
          positionY: this.box.top,
          type: this.getEmojiType(this.checked),
          unicode: this.checked,
          userInfo: { userDisplayName: this.$store.getters.userInfo.userDisplayName },
          userId: this.$store.getters.userInfo.userId,
          local: true,
        })

        this.setCreateEmoji(this.localEmojiKey)
        this.$store.dispatch('setEmoticonList', this.emojiList)
        this.displayEmoji(seekTime)
        this.localEmojiKey += 1
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },
  },
  computed: {
    computedBoxDataStyle() {
      let dynamicStyle
      // for(let item of this.displayingComments)

      this.displayingComments.forEach((comment) => {
        if (comment.boxData.width) {
          dynamicStyle = `width: ${comment.boxData.width}% !important; height: ${comment.boxData.height}% !important; top: ${comment.boxData.top}% !important; left: ${comment.boxData.left}% !important`
        } else dynamicStyle = 'display: none;'
      })

      return dynamicStyle
    },

    isFullScreen() {
      return this.$store.getters.isFullScreen
    },
    getUniques() {
      let tempArray = []
      for (let item of this.displayingEmojiList) {
        ;((tempItem) => {
          if (!(tempItem.length > 0 && tempItem.find((x) => x.brand === item.brand))) tempArray.push(item)
        })(tempArray.filter((x) => x.id === item.id))
      }
      return tempArray
    },
    detailCommentInputComponent() {
      return this.$root.$refs[`DetailCommentInput-${this.sectionIndex}`]
    },
    commentPlayComponent() {
      return this.$root.$refs[`CommentPlay-${this.sectionIndex}`]
    },

    detailComponent() {
      return this.$root.$refs.Detail
    },
    videoControlBarComponent() {
      return this.$root.$refs[`VideoControlBar-${this.sectionIndex}`]
    },
    // isMobile() {
    //   return isMobile()
    // },
    ...mapState({
      currentClip: (state) => {
        return state.clip.currentClip
      },
      duration: (state) => state.clip.duration,
      isMtOrganizer: (state) => {
        if (
          state &&
          state !== null &&
          state.auth &&
          state.auth !== null &&
          state.auth.currentMt &&
          state.auth.currentMt !== null &&
          state.auth.userInfo &&
          state.auth.userInfo !== null
        ) {
          return state.auth.currentMt.mtOrganizerUid === state.auth.userInfo.userId
        } else {
          return false
        }
      },

      isFadeOut: (state) => state.comment.isFadeOut,

      iconList: (state) => state.comment.controlbarIconList,
    }),
    ...mapGetters([
      'emoticonList',
      'removeCommentPlayTimeOut',
      'displayingCommentList',
      'controlbarIconList',
      'chkMtPublic',
      'boxDrawn',
      'isEmojiFadeOut',
      'isFadeOut',
      'userInfo',
    ]),
    isClipOrganizer() {
      let clipUploader =
        this.currentClip !== undefined && this.currentClip !== null ? this.currentClip.clipUploader : null
      if (
        clipUploader &&
        clipUploader !== null &&
        this.$store.getters.userInfo &&
        this.$store.getters.userInfo !== null
      )
        return clipUploader.userId === this.$store.getters.userInfo.userId
      else return false
    },
    isSectionOrganizer() {
      return (
        this.$store.getters.totalSectionList[this.$store.getters.sectionIndex] !== undefined &&
        this.$store.getters.totalSectionList[this.$store.getters.sectionIndex] !== null &&
        this.$store.getters.userInfo !== undefined &&
        this.$store.getters.userInfo !== null &&
        this.$store.getters.totalSectionList[this.$store.getters.sectionIndex].stCreatorUid ==
          this.$store.getters.userInfo.userId
      )
    },
    storeSectionIndex() {
      return this.$store.getters.sectionIndex
    },
    commentBoxData() {
      return this.$store.getters.clickCommentId
    },
    currentDrawingBoxData() {
      return this.$store.getters.boxCommentData
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    windowInnerWidth() {
      return window.innerWidth
    },
    isPreview() {
      return this.sectionIndex === undefined && !this.isIntro
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
  },

  beforeDestroy() {
    if (this.$refs.canvas) {
      this.$refs.canvas.removeEventListener('mousedown', this.onVideoMouseDown)
      this.$refs.canvas.removeEventListener('mouseup', this.onVideoMouseUp)
      this.$refs.canvas.removeEventListener('mousemove', this.onVideoMouseDrag)
    }
    window.removeEventListener('mousedown', this.windowMouseDown)
  },

  watch: {
    cssProps(val) {
      if (val === '') this.isDrawing = false
    },

    clipIndex() {
      this.autoUpdate()
    },
    currentClip() {
      this.autoUpdate()
    },
    sectionIndex() {
      this.autoUpdate()
    },
    containerWidth() {
      if (!this.isMobile) {
        this.$refs.canvas.width = this.containerWidth
        this.$refs.canvas.height = this.containerHeight
      }
      this.drawBox(false)
    },
    isFullScreen: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!this.isInIframe) {
          let cursorPointed = document.querySelectorAll('.pointed')
          let wrapCanvas = document.querySelector('.wrap-canvas')

          const moveCursor = (e) => {
            const rect = wrapCanvas && wrapCanvas?.getBoundingClientRect()
            const mouseY = e.clientY - rect.top
            const mouseX = e.clientX - rect.left

            for (let i = 0; i < cursorPointed.length; i++) {
              if (cursorPointed[i]) cursorPointed[i].style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`
            }
          }

          let mouseEnterEvent = function () {
            for (let i = 0; i < cursorPointed.length; i++) {
              if (cursorPointed[i]) cursorPointed[i].style.display = 'inline-block'
            }
          }

          let mouseLeaveEvent = function () {
            for (let i = 0; i < cursorPointed.length; i++) {
              cursorPointed[i].style.display = 'none'
            }
          }

          if (!val) {
            // 풀스크린 해제시 이벤트 리스너 복원하고 마우스 포인터 삭제
            if (wrapCanvas) {
              wrapCanvas.style.cursor = 'none'
              wrapCanvas.addEventListener('mousemove', moveCursor)
              wrapCanvas.addEventListener('mouseenter', mouseEnterEvent)
              wrapCanvas.addEventListener('mouseleave', mouseLeaveEvent)

              for (let i = 0; i < cursorPointed.length; i++) {
                if (cursorPointed[i]) cursorPointed[i].style.opacity = '1'
              }
            }
          } else {
            wrapCanvas.style.cursor = 'default'
            // 커스텀 커서 삭제하는 부분
            wrapCanvas.removeEventListener('mousemove', moveCursor)
            wrapCanvas.removeEventListener('mouseenter', mouseEnterEvent)
            wrapCanvas.removeEventListener('mouseleave', mouseLeaveEvent)
            for (let i = 0; i < cursorPointed.length; i++) {
              if (cursorPointed[i]) cursorPointed[i].style.opacity = '0'
            }
          }
        }
      },
    },
    guestInVisible(val) {
      this.$store.dispatch('setIsGuestVisible', val)
    },
  },
}
</script>

<style>
.canvas-box-comment {
  /* cursor: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='40'><rect rx='20' stroke='white' stroke-width='2' width='100%' height='100%' fill='black' /><text x='50%' y='50%' font-family='sans-serif' font-weight='bold' font-size='11' dominant-baseline='middle' text-anchor='middle' fill='white'>Drag to Comment</text></svg>")
      16 0,
    auto; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: calc(100% - 8px);
  /* aspect-ratio: 16 / 9;
  width: 100%; */
}
.wrap-canvas {
  cursor: none;
}
.pointed {
  position: absolute;
  display: none;
  top: -8px;
  left: 2px;
  z-index: 198;
  pointer-events: none;
}
.content-zone {
  position: absolute;
  pointer-events: none;
  background-color: transparent;
  border: 5px solid #ff575f;
  border-radius: 15px;
  z-index: 3;
  animation: pulse 1.5s ease-out infinite alternate;
}
.content-zone-displayingComments {
  position: absolute;
  pointer-events: none;
  background-color: transparent;
  border: 5px solid #ff575f;
  border-radius: 15px;
  z-index: 3;
  animation: pulse 1.5s ease-out infinite alternate;
}

.contentZoneFadeOut {
  animation: pulse 1.5s ease-out infinite alternate, fadeout 5s forwards;
}

@keyframes pulse {
  100% {
    transform: scale(0.97);
    opacity: 0.7;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.add-horizon-bg,
.add-vertical-bg {
  position: absolute;
  display: inline-block;
  background-color: white;
  outline: 2px solid black;
  border-radius: 1px;
}
.add-horizon-bg {
  width: 2px;
  height: 14px;
  top: 6px;
  left: 6px;
}
.add-vertical-bg {
  width: 14px;
  height: 2px;
  top: 12px;
}
.add-horizon {
  position: absolute;
  display: inline-block;
  width: 2px;
  height: 14px;
  top: 6px;
  left: 6px;
  background-color: white;
  border-radius: 1px;
}
.box-cursor-text {
  border-radius: 8px;
  display: inline-block;
  position: relative;
  left: 22px;
  background-color: black;
  color: white;
  font-size: 12px;
  font-weight: 600;
}
.delete-emoji {
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 8px;
  width: 20px;
  height: 20px;
  background-color: rgba(19, 27, 30, 0.8);
  transition: all 0.3s;
  cursor: pointer;
  color: #ddd;
}
.delete-emoji:hover {
  background-color: rgba(19, 27, 30, 1);
  color: #ff575f;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.warp-emoji {
  animation: emojiScaleUp 2s ease-out infinite alternate;
}

.warpEmojiFadeOut {
  animation: emojiScaleUp 1.5s ease-out infinite alternate, fadeout 4s forwards;
  /* animation-duration: 0.5s;
  transform-box: fill-box;
  animation-timing-function: cubic-bezier(0.63, 0.09, 0.3, 1.43);
  animation-fill-mode: forwards;
  transform: scale(0); */
}

.emoji-border {
  position: absolute;
  height: 28px;
  width: 28px;

  animation-name: bord-pop;
  animation-duration: 1s;
  border-radius: 100%;
}
@keyframes bord-pop {
  0% {
    transform: translate(-50%, -50%);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.9);
    opacity: 0.1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.9);
    opacity: 0;
  }
}
@keyframes appear {
  0% {
    transform: scaleX(0) scaleY(0) translateY(0);
    opacity: 0;
  }
  5% {
    transform: scaleX(0.7) scaleY(0.7) translateY(0);
  }
  10% {
    transform: scaleX(0.9) scaleY(0.5) translateY(5px);
  }
  20% {
    transform: scaleX(1) scaleY(1) translateY(0);
    opacity: 1;
  }
  30% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.025);
  }

  100% {
    transform: scale(1.075);
  }
}

@keyframes emojiScaleUp {
  0% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1.3);
  }
}

.v-skeleton-loader__avatar {
  width: 28px !important;
  height: 28px !important;
}
</style>
